// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions_container__arBDJ","terms":"TermsAndConditions_terms__1pvfE","link":"TermsAndConditions_link__D3LrK"};